import { TRoutes } from '~/routes/const'
import { routeNames } from '../const'

export default [
  {
    path: routeNames.classificationManagement,
    component: () => import('../../pages/pointsMallManagement/classificationManagement'),
    meta: { title: '分类管理' }
  },
  {
    path: routeNames.IntegralGoodsList,
    component: () => import('../../pages/pointsMallManagement/IntegralGoodsList'),
    meta: { title: '积分商品列表' }
  },
  {
    path: routeNames.addOrEditIntegral,
    component: () => import('../../pages/pointsMallManagement/IntegralGoodsList/addOrEditIntegral'),
    meta: { title: '新增/编辑积分商品', hideInMenu: true }
  },
  {
    path: routeNames.inventoryRecordList,
    component: () => import('../../pages/pointsMallManagement/IntegralGoodsList/inventoryRecordList'),
    meta: { title: '库存记录', hideInMenu: true }
  },
  {
    path: routeNames.exchangeOrderManagement,
    component: () => import('../../pages/pointsMallManagement/exchangeOrderManagement'),
    meta: { title: '兑换订单' }
  },
  {
    path: routeNames.exchangeOrderDetail,
    component: () => import('../../pages/pointsMallManagement/exchangeOrderManagement/exchangeOrderDetail'),
    meta: { title: '库存记录', hideInMenu: true }
  },
  {
    path: routeNames.IntegralRecordManagement,
    component: () => import('../../pages/pointsMallManagement/IntegralRecordManagement'),
    meta: { title: '积分记录' }
  },
  {
    path: routeNames.balanceRecordManagement,
    component: () => import('../../pages/pointsMallManagement/balanceRecordManagement'),
    meta: { title: '现金记录' }
  },
  {
    path: routeNames.clockCommCommodity,
    component: () => import('../../pages/pointsMallManagement/clockCommodity'),
    meta: { title: '打卡商品' }
  }
] as TRoutes[]
